<template>
    <div class="platform-fee-info">
        <modal :display="modalStatus.platformFeeInfo" @modalStatus="closeModal" >
            <h1>收費說明</h1>
            <div class="content">
                收費說明(一)<br>
                親愛的飛豬會員您好，感謝您的支持!!不論在手機APP或是WEB網頁，<br>
                您都可以<span style="color: #fc7171;">免費</span>享有下列六大優勢：<br>
                1. 刊登廣告物件<br>
                2. 編輯電子合約<br>
                3. 帳務管理功能<br>
                4. 房源管理功能<br>
                5. 房客拍錶功能<br>
                6. 主動配對房客<br>
                自動化數位線上代收費用服務：使用平台代收租金時，系統會幫您彙整款項，
                並自動提供財務報表，當房客利用平台繳交租金等費用時，
                平台會抽取租客<span style="color: #fc7171;">租金等費用的2%做為系統服務費</span>，平台收到房客繳交租金後，
                會立刻通知您入帳，您可以立刻提領到您的個人帳戶上。<br>
                <span style="color: #fc7171;font-size:12px;">
                    * 若您在飛豬管家上架超過 50 間以上的房源，飛豬會將您的系統服務費率降為 1%，詳情請加入飛豬官方 LINE 聯繫飛豬客服人員!!
                </span><br><br>

                收費說明(二)<br>
                委託房客出租無縫接軌功能：於期限內順利找到新房客，
                由委託人所提供之<span style="color: #fc7171;">獎勵金的20%</span>做為平台服務費用。
                若委託失敗則將全額退還。
                屋主為委託方，於委託任務期間提供獎金，由平台監管，
                受託於期限內順利找尋新房客，成功讓房源無縫銜接，
                則簽約後獲取委託方提供之獎金80%以示獎勵。
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('新增委託_ATM付款', { screen_name: '新增委託_ATM付款'})

    // },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'platformFeeInfo'})
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    .platform-fee-info{
        .modal-content{
            width: 560px;
            padding: 0 !important;
            .detail{
                align-items: unset !important;
                padding: 32px;
                h1{
                    margin: 0 auto;
                    margin-bottom: 24px;
                    font-size: 32px;
                    color: #fc7171;
                }
                .content{
                    line-height: 1.57;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/platformFeeInfo.vue